import apiFetch from '../apiFetch'

export default function (idUsuario, token) {
  return apiFetch({endPoint: `Usuario/cambiarEstadoUsuario?idUsuario=` + idUsuario, method: 'GET', body: null, token: token})
}